export default function () {
  // removido pra que não seja possivel efetuar agedametno sem selecionar um convenio
  this.doVerifyAfterClose(this.agenda.covenant_id)
  this.covenant = this.dataCovenant
  this.patient = this.dataPatient
  this.doReserve()
  this.doVerifyBeforeClode()
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/form/resources/mounted.js